module.exports = __webpack_public_path__ + "static/img/laohuji.4ab6b9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/laohuji.jpg
// module id = VSyL
// module chunks = 0